import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiServiceService } from 'src/app/_service/api-service.service';
@Component({
  selector: 'app-da-mentor-volunteer',
  templateUrl: './da-mentor-volunteer.component.html',
  styleUrls: ['./da-mentor-volunteer.component.scss']
})
export class DaMentorVolunteerComponent implements OnInit {

  constructor( private ApiService: ApiServiceService, private spinnerService: NgxSpinnerService) { }
  dtOptions: DataTables.Settings = {};
  tableshow: boolean=false;
  spinner: boolean;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  volunteers: any = [];
  ngOnInit(): void {
    //this.spinner=true;
    this.dtOptions = {
      pagingType: 'full_numbers'
    };
    this.ApiService.daGetVolunteerList(this.users.id).subscribe((data: any)=>{
      this.spinner=false;
      this.tableshow=true;
      console.log(data);
      this.volunteers = data;
    });
  }

  public showSpinner(): void {
    this.spinnerService.show();
    }


}
